export class ErrorHandler {
  static errorMap = {
    // Better Auth Errors
    'INVALID_EMAIL_OR_PASSWORD': 'El correo electrónico o la contraseña son incorrectos.',
    'INVALID_EMAIL_PASSWORD': 'El correo electrónico o la contraseña son incorrectos.',
    'INVALID_EMAIL': 'El correo electrónico ingresado no es válido.',
    'USER_NOT_FOUND': 'No se encontró una cuenta con este correo electrónico.',
    'INVALID_PASSWORD': 'La contraseña ingresada es incorrecta.',
    'EMAIL_NOT_VERIFIED': 'Debes verificar tu correo electrónico antes de iniciar sesión.',
    'EMAIL_CAN_NOT_BE_UPDATED': 'No es posible actualizar el correo electrónico de esta manera.',
    'ACCOUNT_NOT_LINKED': 'Esta cuenta no está vinculada. Por favor, inicia sesión con el método original.',
    'INVALID_OAUTH_TOKEN': 'El token de inicio de sesión social es inválido o ha expirado.',
    'USER_ALREADY_EXISTS': 'Ya existe una cuenta registrada con este correo electrónico.',
    'RATE_LIMIT_EXCEEDED': 'Demasiados intentos. Por favor, inténtalo de nuevo más tarde.',
    'SESSION_EXPIRED': 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
    'UNAUTHORIZED': 'No tienes permisos para realizar esta acción.',
    'FORBIDDEN': 'Acceso denegado.',
    'TOKEN_EXPIRED': 'El token ha expirado.',

    // Better Auth Common Strings (fallback)
    'invalid email or password': 'El correo electrónico o la contraseña son incorrectos.',
    'invalid password': 'La contraseña ingresada es incorrecta.',
    'user not found': 'No se encontró una cuenta con este correo electrónico.',
    'email already in use': 'Ya existe una cuenta registrada con este correo electrónico.',
    'user already exists': 'Ya existe una cuenta registrada con este correo electrónico.',

    // Custom API / Database Errors
    'Validation error': 'Uno o más campos ingresados no son válidos. Verifica la información.',
    'SequelizeUniqueConstraintError': 'Ya existe un registro con estos datos únicos.',
    'SequelizeValidationError': 'Los datos ingresados no son válidos.'
  };

  /**
   * Obtiene un mensaje de error amigable a partir de un objeto de error (de Better Auth, Axios o JS nativo)
   * @param {Object|String} error - El objeto de error o código
   * @param {String} defaultMessage - Mensaje por defecto si no se encuentra coincidencia
   * @returns {String} Mensaje de error formateado
   */
  static getMessage(error, defaultMessage = 'Ha ocurrido un error inesperado.') {
    if (!error) return defaultMessage;

    // Si es un string simple, buscar en el mapa o devolverlo tal cual si parece ya ser un mensaje final
    if (typeof error === 'string') {
      return this.errorMap[error] || (error.includes(' ') ? error : defaultMessage);
    }

    // 1. Extraer código de error (para Better Auth)
    const code = error.code || error.error?.code || error.status || error?.response?.data?.code;
    if (code && this.errorMap[code]) {
      return this.errorMap[code];
    }

    // 2. Extraer nombre de error (para Sequelize / Node)
    const name = error.name || error?.response?.data?.name;
    if (name && this.errorMap[name]) {
      return this.errorMap[name];
    }

    // 3. Revisar el mensaje interno (muchas APIs o Better Auth devuelven ENUMs en el .message)
    const message = error.message || error?.response?.data?.error || error?.response?.data?.message;
    
    if (message) {
      const lowerMessage = message.toLowerCase();
      // Si el mensaje es exactamente uno de los ENUM o strings conocidos
      if (this.errorMap[message]) {
        return this.errorMap[message];
      }
      if (this.errorMap[lowerMessage]) {
        return this.errorMap[lowerMessage];
      }
      
      // Si es un mensaje con espacios, probablemente ya sea un texto final y no un código,
      // pero para evitar mostrar mensajes crudos en inglés de bases de datos/etc, hacemos un chequeo rápido
      if (message.includes('Sequelize') || message.includes('database')) {
        return 'Ocurrió un error en la base de datos al procesar la solicitud.';
      }
      
      if (lowerMessage.includes('network') || lowerMessage.includes('failed to fetch')) {
        return 'No se pudo conectar con el servidor. Revisa tu conexión a internet.';
      }

      // Si el mensaje está completamente en MAYÚSCULAS o usa guiones bajos (ej. SERVER_ERROR), usamos el default
      if ((message.includes('_') && message === message.toUpperCase()) || message.startsWith('ERROR_')) {
        return defaultMessage;
      }

      // Devolver el mensaje si parece ser legible y no coincide con las reglas anteriores
      return message;
    }

    return defaultMessage;
  }
}
